'use client'
/* ---------------------------------
Header
--------------------------------- */
import { trackCTAClick } from '@/utils/gtm'
import { DONATION_PATH_ROOT } from '@/utils/donationPaths'
import classNames from 'classnames'
import { Button, Container } from 'components/atoms'
import Image from 'next/image'
import { useRouter, useSearchParams } from 'next/navigation'
import { Suspense } from 'react'
import { extractStyleProps } from 'utils/styleProps'

export default function Header({
  className,
  containerStyleProps,
  isDonationPage = false,
  ...styleProps
}) {
  return (
    <Suspense fallback={null}>
      <HeaderWrapper
        className={className}
        containerStyleProps={containerStyleProps}
        isDonationPage={isDonationPage}
        {...styleProps}
      />
    </Suspense>
  )
}

function HeaderWrapper({
  children,
  className,
  isDonationPage,
  containerStyleProps,
  ...styleProps
}) {
  const router = useRouter()
  const searchParams = useSearchParams()
  return (
    <header
      className={classNames('Header', className, extractStyleProps(styleProps))}
    >
      <Container
        className={classNames(
          `Header__wrapper ${isDonationPage ? 'Header__wrapper--donation' : ''}`,
          extractStyleProps(containerStyleProps)
        )}
      >
        <div
          className='Header__logo'
          onClick={() => {
            router.push('/')
          }}
        >
          <Image
            src='/assets/image/AIRC-logo.svg'
            alt='Logo di AIRC'
            fill
            priority
          />
          <span className='Header__logo__claim'>
            Affrontiamo il cancro. Insieme.
          </span>
        </div>

        {!isDonationPage ? (
          <div className='Header__CTA'>
            <Button
              variant={'cta'}
              onClick={() => {
                trackCTAClick('header-donate')
                const donateUrl = `${DONATION_PATH_ROOT}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`
                router.push(donateUrl)
              }}
            >
              Dona
            </Button>
          </div>
        ) : null}
      </Container>
    </header>
  )
}
